import { TableUserListCell } from '../TableUserListCell'

import ProviderIcon from '../../../../icons/provider.svg'

function TableProviderListCell(props) {
  return (
    <TableUserListCell
      {...props}
      listProps={{
        itemProps: { Icon: ProviderIcon },
        moreItemsProps: { itemProps: { Icon: ProviderIcon } },
      }}
    />
  )
}

export default TableProviderListCell
